import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ProductService } from '../services/product.service';
import { WarehouseService } from '../services/warehouse.service';
import { Product } from '../models/product.model';
import { Warehouse } from '../models/warehouse.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'product',
  templateUrl: '../views/products/product.html',
  providers: [ProductService, WarehouseService]
})
export class ProductComponent{
  public title: string;
  public products: Product[];
  public warehouses: Warehouse[];
  public submitProductModel: Product;
  public message: any;
  public mode: string;
  public wait:boolean;
  public inventaryPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private productService: ProductService,
    public sharedVariables: VariableService,
    private warehouseService: WarehouseService
  )
  {

      this.title = null;
      this.mode = "submit-add";
      this.submitProductModel = new Product(0,'','',0,0,0);
      this.wait = true;
      this.inventaryPrivilege = null;

  }
  
  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.inventaryPrivilege == 1){
                                    this.getAllProducts();
                                    this.getAllWarehouses();
                                    this.wait=false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllProducts()
  {
    this.productService.getProducts().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.products = result.data;
          console.log(this.products);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }
  getAllWarehouses()
  {
    this.warehouseService.getWarehouses().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.warehouses = result.data;
          console.log(this.warehouses);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveProduct();
    }else{
      this.updateProduct();
    }

    this.mode = "submit-add";
    setTimeout(()=> {
                      this.message = null;
                    },this.sharedVariables.timeMessage);
    setTimeout(()=> {
                      this.getAllProducts();
                      this.submitProductModel =  new Product(0,'','',0,0,0);
                    },this.sharedVariables.timeToLoad);
    console.log("mode",this.mode);
  }

  saveProduct()
  {
    this.productService.addProduct(this.submitProductModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
          this.getAllProducts();
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }


  editProduct(pProduct: Product)
  {
    this.mode = "submit-update";
    this.submitProductModel = Object.assign({}, pProduct);

    console.log("Checkout objects");
    console.log("mode ",this.mode);
  }

  updateProduct()
  {
    /*this._route.params.forEach((params: Params)=>{*/
      let id = this.submitProductModel.ID;
      console.log("objeto update ",this.submitProductModel);
      this.productService.updateProduct(id,this.submitProductModel).subscribe(
        response => {
          if(response.code == 200)
          {
            //this._router.navigate(['/productos']);
            this.getAllProducts();
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
      /*});*/
  }

  deleteProduct(id: number)
  {
    this.productService.deleteProduct(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllProducts();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  cleanObject()
  {
    this.submitProductModel = new Product(0,'','',0,0,0);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.inventaryPrivilege = response.data[0].Inventary;
            console.log("Privilegios del usuario",this.inventaryPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/product.component.ts